import { Header } from '../../components/common/Header';
import { ClearingsTable } from './ClearingsTable';
import { ClearingsFilters, useClearingsFilters } from './ClearingsFilters';

export function ClearingsList(): JSX.Element {
  const [filters] = useClearingsFilters();

  return (
    <>
      <Header title="Liquidaciones" />
      <ClearingsFilters filters={filters} />
      <ClearingsTable filters={filters} trackingContext="clearing screen" />
    </>
  );
}
